<template>
  <div class="head_wrap animate__animated animate__fadeInDown">
    <div class="head">
      <div class="head_con">
        <img src="../../static/img/logo.png" alt="" class="logo">
        <ul class="menu_list">
          <router-link to="/" exact>
            <li class>
              <a href="javascript:;">
                <i class="c_line"></i>{{ $t('language.home') }}
              </a>
            </li>
          </router-link>
          <li class="sel">
            <select v-model="selectLanguage" @change="handleSelect($event)">
              <option v-for="(options,id) in language" :key="id" :value="options.id" class="opt">
                {{options.title}}
              </option>
            </select>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../vuex/store";

export default {
  data() {
    return {
      isshow: false,
      selectLanguage: "en",
      language:[ //类别选择数据或者从后台获取数据
        {id:"zh",title:"中文繁体"},
        {id:"en",title:"English"},
        {id:"kr",title:"한국어"},
      ]
    };
  },
  mounted: function () {

  },

  methods: {
    changeShow: function () {
      this.isshow = true
    },
    leveaShow: function () {
      this.isshow = false
    },
    handleSelect: function (event){
      store.commit('changLang', event.target.value)
    }
  }
};
</script>
<style scoped>
.sel:before{content:"";position:absolute;width:0;line-height: 100px;border:.5rem solid transparent;
  border-top-color:#ffffff;top:60%;right:1rem;cursor:pointer;z-index:-2;margin-top:-0.25rem;}
select{
  color: white;
  width:100%;
  border:none;
  font-size: 16px;
  line-height: 100px;
  background:transparent;
  background-image:none;
  -webkit-appearance:none;
  -moz-appearance:none;
  appearance:none;
  vertical-align:top;padding-left:1rem;}
option{
  color: black;
}
select:focus{outline:none;}
.show-enter-active,
.show-leave-active {
  transition: all .3s;
}
.opt:hover{
  background-color: #ff7c54 !important;
  cursor: pointer;
}
.show-enter,
.show-leave-to {
  height: 0px
}

.show-enter-to,
.show-leave {
  height: 80px
}

.li_ul {
  padding: 0;
  width: 124px;
  overflow: hidden;
  margin-top: 78px;
  text-align: center;
  background-color: #fff
}

.menu_list .li_ul li {
  width: 130px;
  text-align: center;
  line-height: 40px
}

.login {
  position: absolute;
  top: 0;
  right: 10px;
  color: #888
}

.head_wrap {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  height: 90px;
  background: rgba(0, 0, 0, 0.6)
}

.head_con {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.head_con .logo {
  display: block;
  overflow: hidden;
  position: absolute;
  left: 15px;
  top: 12px;
}

.menu_list {
  display: block;
  width: auto;
  list-style: none;
  height: 80px;
  position: absolute;
  right: 0;
  top: 0px;
  margin: 0;
}

.menu_list li {
  width: 130px;
  display: block;
  float: left;
}

.menu_list li a {
  width: auto;
  display: block;
  float: left;
  height: 80px;
  padding: 0 30px;
  line-height: 100px;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  position: relative;
  text-align: center;
  -webkit-transition: font-weight 0.3s;
  transition: font-weight 0.3s;
}

/* .menu_list li a:hover{
  color:#fcc916
} */
.menu_list a.active a .c_line,
.menu_list li:hover a .c_line {
  display: block;
}

.menu_list li a .c_line {
  display: none;
  height: 2px;
  width: 40px;
  background: #fcc916;
  overflow: hidden;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  bottom: 0;
  -webkit-transition: bottom 0.2s;
  transition: bottom 0.2s;
}

.menu_list li a .s_line {
  display: block;
  height: 13px;
  width: 1px;
  background: #fff;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -6.5px;
  opacity: 0.3;
  filter: alpha(opacity=30);
}

.menu_list .language_1 a.current {
  opacity: 1;
  filter: alpha(opacity=100);
}

.menu_list .language_1 a:hover {
  font-weight: 400;
  opacity: 1;
  filter: alpha(opacity=100);
}

.menu_list .language_1 .simple {
  margin-left: 20px;
}

.menu_list .language_1 a {
  height: 20px;
  width: auto;
  font-size: 14px;
  line-height: 20px;
  margin-top: 40px;
  padding: 0 8px;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue